module.exports = __webpack_public_path__ + "static/media/fa-solid-900.de1d242d.svg";